import { createContext } from "react";

export interface ISurveyInvalidGroupQuestionIndexContextValue {
  index: string;
  setIndex: React.Dispatch<React.SetStateAction<string>>;
}

export const SurveyInvalidGroupQuestionIndexContext =
  createContext<ISurveyInvalidGroupQuestionIndexContextValue | null>(null);